import { constants } from '@common/services'
import { canUseDOM } from '@common/utils'

const set = (key, value) => {
  canUseDOM &&
    window.localStorage.setItem(
      `${constants.LOCALSTORAGE_NAMESPACE}__${key}`,
      JSON.stringify(value)
    )
}

const get = key => {
  const data = canUseDOM
    ? window.localStorage.getItem(`${constants.LOCALSTORAGE_NAMESPACE}__${key}`)
    : null
  try {
    return JSON.parse(data)
  } catch (e) {
    return data
  }
}

const remove = key => {
  canUseDOM &&
    window.localStorage.removeItem(
      `${constants.LOCALSTORAGE_NAMESPACE}__${key}`
    )
}

export default {
  get,
  set,
  remove
}
